import React from 'react'
import { useSelector } from 'react-redux'
import DialogModal from '../DialogModal/DialogModal'
import DeviceMissMatchPopupCom from './DeviceMissMatchPopupCom'

/**
 * HeaderDialogs
 * -------------------------------------------------
 * The three dialog modals rendered by the header:
 *   1. Device mismatch prompt
 *   2. Humanoid memory-card / arm-position prompt
 *   3. Connection-error prompt
 */
export default function HeaderDialogs({
    isDeviceMismatch,
    setIsDeviceMismatch,
    handleDevice,
    connectedDevice,
    deviceVersion,
    deviceName,
    webSerial,
    device,
    history,
    showErrorMsg,
    setshowErrorMsg,
    handleError,
}) {
    return (
        <>
            <DialogModal
                mismatchShow={isDeviceMismatch}
                text={<DeviceMissMatchPopupCom />}
                showCloseBtn={true}
                handleDialogModalClose={() => setIsDeviceMismatch(false)}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => handleDevice('yes'),
                    },
                ]}
            />
            {/* Old memory-card dialog for Zing: replaced by the firmware SD-card
                notification (ZingNotificationHost). */}
            {/*
            <DialogModal
                mismatchShow={
                    connectedDevice == 'Humanoid' &&
                    deviceVersion?.startsWith('2') &&
                    webSerial.isConnected &&
                    !isDeviceMismatch &&
                    !device.isMemoryPresent
                }
                text={
                    !device.isMemoryPresent
                        ? `There is no memory card inserted in ${deviceName}. \nkindly insert one to use the application further.`
                        : ''
                }
                showCloseBtn={false}
                optionsToSelect={[
                    {
                        text: 'YES',
                        do: () => history.push('/kitSelection'),
                    },
                ]}
            />
            */}
            <DialogModal
                showError={showErrorMsg}
                text={
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2.5vh',
                            }}
                        >
                            Error in connecting the device!
                        </p>
                        <p
                            style={{
                                transform: 'translateY(20%)',
                                fontSize: '2vh',
                            }}
                        >
                            Please disconnect the device and try connecting
                            again.
                        </p>
                    </div>
                }
                showCloseBtn={true}
                handleDialogModalClose={() => setshowErrorMsg(false)}
                optionsToSelect={[
                    {
                        text: 'OK',
                        do: handleError,
                    },
                ]}
            />
        </>
    )
}
